import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
} from "@material-ui/core";
import {UserId} from "common/types/user";
import React from "react";
import {getMessageUsername} from "./util/get_message_username";
import {ConversationUserInfo} from "common/types/conversation";

interface UserSelectProps {
  users: ConversationUserInfo[];
  shownUserIds: UserId[];
  setShownUserIds: (ids: UserId[]) => void;
}

export default function UserSelect({
  users,
  shownUserIds,
  setShownUserIds,
}: UserSelectProps) {
  const handleChange = event => {
    const {
      target: {value},
    } = event;
    setShownUserIds(value);
  };

  const getSelectRenderValue = (selectedIds: UserId[]) => {
    if (selectedIds.length > 0) {
      return users
        .filter(user => selectedIds.includes(user.id))
        .map(user => getMessageUsername({user}))
        .join(", ");
    }
    return "-";
  };

  return (
    <div>
      <FormControl style={{width: "10em"}}>
        <InputLabel id="input-select-label">Users</InputLabel>
        <Select
          multiple
          labelId="input-select-label"
          id="input-select"
          value={shownUserIds}
          onChange={handleChange}
          renderValue={getSelectRenderValue}
        >
          {users.map(user => (
            <MenuItem key={user.id} value={user.id}>
              <Checkbox checked={shownUserIds.includes(user.id)} />
              <ListItemText primary={getMessageUsername({user})} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
